import * as TYPES from './types';
export default {
    [TYPES.SET_SEO_DATA](payload = {}) {
        this.seoData = payload
    }
}